<h4 class="are-you-the-driver__title" i18n="@@configurator.driver.question-one.title">
    Will you be the driver for this car?
</h4>

<form [formGroup]="form">
    <mg-checkout-driver [formControl]="componentFormControl"></mg-checkout-driver>
</form>

<mg-deal-user-profile
    [displayName]="true"
    [displayPhonenumber]="true"
    [displayAddress]="false"
    [class.userIsDriver]="userIsDriver$ | async"
></mg-deal-user-profile>
